import { SpotlightTable, SpotlightVisualGuidelines, SpotlightCollectionBackgroundColors } from '@af/design-system-docs-ui';
import { Stack } from '@atlaskit/primitives/compiled';
import tourUseDo from "../../../../../../packages/design-system/spotlight/constellation/images/tour-use-do.png";
import tourUseDont from "../../../../../../packages/design-system/spotlight/constellation/images/tour-use-dont.png";
import principlesDo from "../../../../../../packages/design-system/spotlight/constellation/images/principles-of-use-do.png";
import principlesDont from "../../../../../../packages/design-system/spotlight/constellation/images/principles-of-use-dont.png";
import * as React from 'react';
export default {
  SpotlightTable,
  SpotlightVisualGuidelines,
  SpotlightCollectionBackgroundColors,
  Stack,
  tourUseDo,
  tourUseDont,
  principlesDo,
  principlesDont,
  React
};